import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'customerEmailFilter'
})
export class SearchPipe implements PipeTransform {

    transform(courses: any[], searchTerm: string): any[] {
        if (!courses || !searchTerm) {
          return courses;
        }
    
        searchTerm = searchTerm.toLowerCase();
    
        return courses.filter(course => {
          const courseCode = course.value.CoCgCoCode.toLowerCase();
          return courseCode.includes(searchTerm);
        });
      }
}